import { MAX_CHAT_MESSAGES_PER_CHANNEL } from '@game/constants';
import type { ChatCommand, ChatEmotes } from '@game/game-data';
import type { ClientChatMessage } from '@game/shared-types';

export interface ChatState {
  adminItemSchematicNames: string[];
  chatCommands: ChatCommand[];
  chatChannels: Record<string, string>;
  chatMessages: ClientChatMessage[]; // All chat messages, before filtering by channel
  chatEmotes: ChatEmotes;
  addChatMessageSuccess?: boolean;
  chatAvatars: Record<string, string>;
  channelsUnreadMessages: Record<string, number>;
  chatChannelMessages: ClientChatMessage[]; // Chat messages for the current channel
  channelFirstItemIndexes: Record<string, number>;
  channelHasOlderMessages: Record<string, boolean>;
  loadingMoreMessages: boolean;
  openedUrl?: URL;
}

export const chatDefault: ChatState = {
  adminItemSchematicNames: [],
  chatCommands: [],
  chatChannels: {
    main: 'Main',
    trade: 'Trade',
  },
  chatMessages: [],
  chatEmotes: {},
  chatAvatars: {},
  channelsUnreadMessages: {},
  chatChannelMessages: [],
  loadingMoreMessages: false,
  channelFirstItemIndexes: {
    main: MAX_CHAT_MESSAGES_PER_CHANNEL,
    trade: MAX_CHAT_MESSAGES_PER_CHANNEL,
  },
  channelHasOlderMessages: {
    main: true,
    trade: false,
  },
};
